module.exports = __webpack_public_path__ + "img/153.zap.3be42f77.svg";